const problemOptions = [
  {
    label: 'o produto veio danificado ou com defeito',
    value: 'BROKEN_PRODUCT',
  },
  {
    label: 'recebi o produto errado',
    value: 'WRONG_PRODUCT',
  },
  {
    label: 'o produto veio incompleto',
    value: 'INCOMPLETE_PRODUCT',
  },
  {
    label: 'o produto não é original',
    value: 'FAKE_PRODUCT',
  },
  {
    label: 'o produto é diferente da descrição ou foto',
    value: 'DIFFERENT_PRODUCT',
  },
  {
    label: 'outro',
    value: 'OTHER',
  },
];

export default problemOptions;
export { problemOptions };
